import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type AgentFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AgentFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: AgentFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.526312 -2.526415) scale(1.210526)',
        },
        [
          h(
            'path',
            {
              d: 'M5.79592 12.1649V7.33732C5.72806 7.33732 5.6602 7.33732 5.59235 7.34701C6.68776 4.97201 9.13061 3.31436 11.9709 3.31436C14.8112 3.31436 17.2541 4.97201 18.3495 7.34701C18.2816 7.33732 18.2138 7.33732 18.1459 7.33732V12.1746C19.5128 12.1746 20.6179 11.0888 20.6179 9.76079C20.6179 8.85926 20.1041 8.06436 19.3577 7.64752C18.2913 4.65211 15.3929 2.50977 11.9806 2.50977C8.55867 2.50977 5.6602 4.66181 4.60357 7.64752C3.84745 8.06436 3.34337 8.84956 3.34337 9.76079C3.32398 11.0888 4.42908 12.1649 5.79592 12.1649ZM17.3026 14.9373C15.9066 16.2169 14.026 16.9924 11.9709 16.9924C9.91582 16.9924 8.0352 16.2169 6.63929 14.9373C4.13827 16.2072 2.5 18.4465 2.5 21.4904H21.5C21.5 18.4368 19.8327 16.1975 17.3026 14.9373Z',
            },
          ),
          h(
            'path',
            {
              d: 'M11.971 4.92383C9.01432 4.92383 6.61993 7.26975 6.61993 10.1585C6.61993 13.0473 9.01432 15.3932 11.971 15.3932C14.9276 15.3932 17.322 13.0473 17.322 10.1585C17.3123 7.26975 14.9179 4.92383 11.971 4.92383ZM12 13.183C11.1082 13.183 10.3812 12.6498 10.3812 11.9907H13.6189C13.6189 12.6498 12.8919 13.183 12 13.183Z',
            },
          ),
        ],
      ),
    ],
  );

export default AgentFilled;
